export enum Status {
  OPEN = "OPEN",
  SCHEDULED = "SCHEDULED",
  CLOSED = "CLOSED",
  CANCELLED = "CANCELLED",
}
